module.exports = __webpack_public_path__ + "img/user.12d9ea23.jpg";